import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = {
  key: 0,
  class: "prefix"
}
const _hoisted_3 = {
  key: 1,
  class: "sufix"
}
const _hoisted_4 = {
  key: 1,
  class: "error-message"
}

import { ref, watchEffect } from "vue";
import moment from "moment";
import Calendar from "primevue/calendar";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-hour',
  props: {
    width: { default: "100%" },
    height: { default: "2.5rem" },
    radius: { default: "0.375rem" },
    background: { default: "#fff" },
    placeholder: {},
    value: {},
    disabled: { type: Boolean },
    valueMask: {}
  },
  emits: ["update:modelValue", "select-time", "key:enter"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v0347a31d": (_ctx.width),
  "v4bddc6b0": (_ctx.height),
  "v5cb3a21b": (_ctx.radius),
  "v5d259e37": (_ctx.background)
}))

const props = __props;

const emit = __emit;

const internalValue = ref<Date | null>(null);

function update(value: any) {
  const time = moment(value).format("HH:mm:ss");
  emit("update:modelValue", time);
}

watchEffect(() => {
  if (!props.value) {
    internalValue.value = null;
  } else if (props.value) {
    const valueFormat = moment(
      props.value,
      props.valueMask || "HH:mm:ss"
    ).toDate();
    internalValue.value = valueFormat;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-input", { disabled: __props.disabled }])
  }, [
    (_ctx.$slots.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "label")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["content", { error: _ctx.$slots.error }])
    }, [
      (_ctx.$slots.prefix)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "prefix")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["input", { pref: _ctx.$slots.prefix, suf: _ctx.$slots.sufix }])
      }, [
        _createVNode(_unref(Calendar), {
          modelValue: internalValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
          class: "calendar-hour",
          placeholder: props.placeholder || '--:--:--',
          manualInput: true,
          showSeconds: "",
          hourFormat: "24",
          showIcon: "",
          timeOnly: "",
          fluid: "",
          iconDisplay: "input",
          onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (update($event)))
        }, null, 8, ["modelValue", "placeholder"])
      ], 2),
      (_ctx.$slots.sufix)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "sufix")
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.$slots.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "error")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})